/* tslint:disable */

/**
 */
export class HeadBalanceResult {
    vc?: number;
    id?: number;
    equipName?: string;
    runBrainPopup?: boolean;
    calculWarning?: number;
    calculate?: boolean;
    tr?: number;
    ts?: number;
    specificSize?: string;
    vep?: number;
    tfp?: number;
    dhp?: number;
    conso?: string;
    conso_warning?: string;
    toc?: string;
    precision?: number;
    background?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/head-balance-result.ts